import React,{useState} from 'react';
import styled from "styled-components"
import LineDivider from '../LineDivider'
import LoadMoreArrow from '../../../../assets/imgs/icons/load-more-arrow.svg';

const CreditCardTransactionDetails = (props) => {
    const [showCount,setShowCount] = useState(3); 

    const {TransactionDetails} = props;

   // console.log(TransactionDetails);
    const showMiniStatement = (val)=>{
        return TransactionDetails.slice(0,showCount).map((item,i)=>{
            return(
                <React.Fragment key={i}>
                    <MiniStatement>
                        <div className = "block-header">
                            <div>
                              <b>Date:</b> {item.Date}
                            </div>
                        </div>
                        <div className="block-footer">
                            <div>
                                <div>
                                  {item.narrative}
                                </div>
                                <div className={`value ${item.type}`}>
                                 Rs. {item.amount}
                                </div>
                            </div>
                     
                        </div>
                    </MiniStatement>
                    {i!==TransactionDetails.length - 1 && <LineDivider />}
                    {showCount < TransactionDetails.length &&  i === showCount - 1 && <LoadMore onClick={()=>setShowCount(showCount + 3)}>Load More <img src={LoadMoreArrow} alt="load more icon"/></LoadMore>}
                </React.Fragment>
            )
        });
    }
    return (
        <React.Fragment>
            {showMiniStatement()}
        </React.Fragment>
    );
};

const MiniStatement = styled.div`
    display:flex;
    flex-direction : column;
    margin-top : 15px;
    & .block-footer{
        display:flex;
        justify-content:space-between;
        margin-top : 10px;
        >div:first-child{
            margin-right:15px;
        }
    }
    & .value{
        margin-top : 3px;
        font-weight: 500;
        color: #2c387a;
        // &.Credited{
        //     color : #31ba74;
        // }
        // &.Debited{
        //     color : #d82424;
        // }
    }
    
`

const LoadMore = styled.div`
    color: #707070;
    text-align : center;
    cursor: pointer;
    img{
        margin-left: 2px;
        vertical-align: middle;
    }
`

export default CreditCardTransactionDetails;